import { TreeItemIconContainer } from "@mui/x-tree-view-pro";
import { MdsDragIndicator } from "@sinch/icons";
import React, { FC } from "react";
import { MdsIcon } from "@sinch/components";

export const RateBuilderDragHandle: FC = () => (
  <TreeItemIconContainer>
    <MdsIcon fontSize="small" icon={MdsDragIndicator} />
  </TreeItemIconContainer>
);
